import React from 'react';


const DelimiterVertical = () => <span className="ms-2 me-2">|</span>;

export default DelimiterVertical;
